import { render, staticRenderFns } from "./copyright-icp.vue?vue&type=template&id=72170b98&"
import script from "./copyright-icp.vue?vue&type=script&setup=true&lang=js&"
export * from "./copyright-icp.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./copyright-icp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports